/**
 * Purpose: Loading skeleton primitives for async sections (D-16 performance requirement).
 * Inputs: Skeleton — className sets shape/size. SkeletonText — lines. SkeletonCircle — size class.
 * Outputs: pulsing placeholders; aria-hidden (surrounding section should carry aria-busy).
 */
import React from 'react';

export const Skeleton = ({ className = '' }) => (
  <span
    aria-hidden
    className={`block animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700 ${className}`}
  />
);

export const SkeletonText = ({ lines = 3, className = '' }) => (
  <span aria-hidden className={`block space-y-2 ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} className={`h-3.5 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} />
    ))}
  </span>
);

export const SkeletonCircle = ({ className = 'h-10 w-10' }) => (
  <span aria-hidden className={`block animate-pulse rounded-full bg-gray-200 dark:bg-gray-700 ${className}`} />
);

export default Skeleton;
